export default "__VITE_ASSET__Cs8kyx1y__"